import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { StyledDrawer } from "./Sidebar.styles";
import useResponsive from "../../hooks/useResponsive";
import { styled } from "@mui/material/styles";
import logo from "../../assets/images/guardianonetransport_logo.png";
import { StyledToolbar } from "./Sidebar.styles";
import NavSection from "../../components/NavSection/NavSection";

const NAV_WIDTH = 200;

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

export const StyledLogo = styled("img")(({ theme }) => ({
  height: "30",
}));

const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {
  const isDesktop = useResponsive("up", "lg");

  useEffect(() => {
    if (open) {
      onClose();
    }
  }, []);

  const [selectedIndex, setSelectedIndex] = React.useState<number>(0);

  const handleListItemClick = (index: number) => {
    setSelectedIndex(index);
  };

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      <StyledDrawer
        variant={isDesktop ? "permanent" : "temporary"}
        open={open}
        onClose={onClose}
      >
        <StyledToolbar>
          <Box sx={{ px: 3, py: 3, display: "inline-flex" }}>
            <StyledLogo src={logo} alt="logo" />
          </Box>
        </StyledToolbar>
        <NavSection />
      </StyledDrawer>
    </Box>
  );
};

export default Sidebar;
